import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";

import { DetailLayout } from "@/layouts/DetailLayout/DetailLayout";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { DetailLayoutBox } from "@/modules/theme/components/DetailLayoutBox";
import { Loader } from "@/modules/theme/components/Loader/Loader";
import { PointsLabel } from "@/modules/theme/components/PointsLabel";
import { grey } from "@/modules/theme/utils/colors";

import { SubtaskForm } from "./components/SubtaskForm";
import { TaskStatusToggler } from "./components/TaskStatusToggler";
import { useCompleteSubtaskMutation } from "./hooks/useCompleteSubtaskMutation";
import { useSubtaskDetailsQuery } from "./hooks/useSubtaskDetailsQuery";
import { createSubtaskDetailsPageStyles } from "./styles/createSubtaskDetailsPageStyles";

const formId = "subtask-form";

export const UndoneSubtaskDetailsPage = () => {
  const classes = createSubtaskDetailsPageStyles();
  const subtaskDetailsParams = authenticatedRouting.useRouteParams(
    "undoneSubtaskDetails"
  );
  const {
    data: subtaskDetailsData,
    isFetching: areSubtaskDetailsFetching,
  } = useSubtaskDetailsQuery(subtaskDetailsParams?.id);
  const history = useHistory();
  const completeSubtaskMutation = useCompleteSubtaskMutation(() =>
    history.goBack()
  );
  const areRequestsPending =
    areSubtaskDetailsFetching || completeSubtaskMutation.status === "loading";

  return (
    <DetailLayout
      variant="task"
      heading={
        areSubtaskDetailsFetching ? (
          <Skeleton className={classes.headingSkeleton} />
        ) : (
          subtaskDetailsData?.name
        )
      }
      details={
        areSubtaskDetailsFetching ? (
          <Skeleton
            width={50}
            height={20}
            baseColor={grey[900]}
            highlightColor={grey[800]}
          />
        ) : (
          <PointsLabel points={subtaskDetailsData?.pointsNumber ?? 0} />
        )
      }
    >
      <DetailLayoutBox isTogglerVisible>
        {areSubtaskDetailsFetching ? (
          <div className={classes.loaderWrapper}>
            <Loader size={70} variant="primary" />
          </div>
        ) : (
          subtaskDetailsData && (
            <SubtaskForm
              description={subtaskDetailsData.description}
              tutorialId={subtaskDetailsData.tutorial}
              formId={formId}
              completeSubtaskMutate={completeSubtaskMutation.mutate}
            />
          )
        )}
        <TaskStatusToggler
          done={false}
          formId={formId}
          isLoading={areRequestsPending}
          isDisabled={areRequestsPending}
        />
      </DetailLayoutBox>
    </DetailLayout>
  );
};
